import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "miscGift"
const MiscGiftIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M16.238 7.394h4.368c.206 0 .394.166.394.386v2.207c0 .22-.188.386-.394.386h-7.969V7.449h-1.274v2.924h-7.97A.392.392 0 013 9.987V7.78c0-.22.188-.386.394-.386h4.369c-.638-.092-1.05-.386-1.294-.643-.394-.386-.6-.938-.6-1.508C5.869 4.158 6.675 3 8.156 3c1.069 0 2.213.588 3.413 1.765.072.08.145.156.216.23.075.078.147.154.215.23.131-.147.281-.313.431-.46C13.631 3.588 14.775 3 15.844 3c.675 0 1.275.257 1.706.717.375.405.581.956.581 1.526 0 .57-.206 1.103-.6 1.508-.244.257-.656.551-1.294.643zm-9.094-2.17c0 .46.281.938 1.087.938h2.888c-.806-.9-1.969-1.912-2.981-1.912-.788 0-.994.607-.994.975zm5.719.938c.806-.882 1.968-1.912 2.98-1.912.788 0 .995.607.995.975a.945.945 0 01-.244.643c-.188.202-.469.294-.844.294z"
        fillRule="evenodd"
      />
      <path d="M4.088 20.485c0 .276.243.515.525.515h6.768v-9.395H4.087zM12.656 21h6.75a.531.531 0 00.525-.515v-8.88h-7.275z" />
    </svg>
  )
}
export default MiscGiftIcon
